 import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={styles.pageWrapper}>
      <style>
        {`
          @media (max-width: 900px) {
            .header-box {
              flex-direction: column !important;
              text-align: center !important;
            }
            .card {
              padding: 18px !important;
            }
          }

          .pp-list { margin-top: 6px; }
          .pp-list li { margin: 6px 0; }
          .pp-sublist { margin-top: 6px; }
        `}
      </style>

      {/* Header */}
      <div style={styles.headerSection}>
        <div className="header-box" style={styles.header}>
          <h1 style={styles.heading}>Maamaas Movers Privacy Policy</h1>
        </div>
      </div>

      {/* Content */}
      <div className="card" style={styles.card}>
        <h2 style={styles.title}>📜 Maamaas Movers Policy</h2>

        <p style={styles.meta}><strong>Last Updated:</strong> 18 Feb 2025</p>
        <p style={styles.meta}><strong>Company:</strong> Envision Integrated Services Pvt Ltd</p>
        <p style={styles.meta}><strong>App Name:</strong> Maamaas Movers</p>
        <p style={styles.meta}><strong>Contact Email:</strong> <a href="mailto:envisionis.it@gmail.com">envisionis.it@gmail.com</a></p>

        <hr style={styles.line} />

        <Section title="1. Introduction">
          <ul style={styles.list} className="pp-list">
            <li>
              Welcome to Maamaas Movers, operated by Envision Integrated Services Pvt Ltd.
              This Privacy Policy explains how we collect, use, disclose, and
              protect information when you use our Delivery Partner application.
            </li>
            <li>By using this App, you agree to this Privacy Policy.</li>
          </ul>
        </Section>

        <Section title="2. Information We Collect">
          <ul style={styles.list} className="pp-list">
            <li>
              <strong>A. Personal Information</strong>
              <ul style={styles.subList} className="pp-sublist">
                <li>Full Name</li>
                <li>Phone Number</li>
                <li>Email Address</li>
                <li>Profile Photo</li>
                <li>Address</li>
                <li>Government IDs (if required for verification)</li>
                <li>Bank account / UPI details (for payouts)</li>
                <li>Feedback or messages sent via the app</li>
              </ul>
            </li>

            <li>
              <strong>B. Location Information</strong>
              <ul style={styles.subList} className="pp-sublist">
                <li>Real-time location (foreground & background)</li>
                <li>Device GPS data</li>
                <li>Assign nearby orders</li>
                <li>Track deliveries</li>
                <li>Show route navigation</li>
                <li>Ensure safety and order accuracy</li>
                <li>
                  Location tracking may continue in background only during active delivery.
                </li>
              </ul>
            </li>

            <li>
              <strong>C. Device Information</strong>
              <ul style={styles.subList} className="pp-sublist">
                <li>Device model</li>
                {/* <li>OS version</li>
                <li>App version</li> */}
                <li>Crash logs</li>
              </ul>
            </li>
          </ul>
        </Section>

        <Section title="3. How We Use Your Information">
          <ul style={styles.list} className="pp-list">
            <li>Create and manage your delivery partner account</li>
            <li>Assign and track deliveries</li>
            <li>Process earnings and payments</li>
            <li>Provide customer support</li>
            <li>Prevent fraud and misuse</li>
            <li>Comply with legal obligations</li>
          </ul>
        </Section>

        <Section title="4. Data Sharing">
          <ul style={styles.list} className="pp-list">
            <li>Customers (limited info during delivery)</li>
            <li>Restaurants / vendors</li>
            <li>Payment gateway (Razorpay)</li>
            <li>Government authorities if legally required</li>
            <li>We do NOT sell your personal data.</li>
          </ul>
        </Section>

        <Section title="5. Data Storage & Security">
          <ul style={styles.list} className="pp-list">
            <li>We implement reasonable security measures.</li>
            <li>No method of transmission is 100% secure.</li>
            <li>Payments are handled securely by Razorpay.</li>
          </ul>
        </Section>

        <Section title="6. Data Retention">
          <ul style={styles.list} className="pp-list">
            <li>Data retained while account is active.</li>
            <li>Retained as required by legal obligations.</li>
            <li>Used for dispute resolution and fraud prevention.</li>
            <li>You may request account deletion by contacting us.</li>
          </ul>
        </Section>

        <Section title="7. Your Rights">
          <ul style={styles.list} className="pp-list">
            <li>Access your data</li>
            <li>Update incorrect information</li>
            <li>Request deletion</li>
            <li>Withdraw consent (may affect app usage)</li>
            <li>Contact: it.envisionis@gmail.com</li>
          </ul>
        </Section>

        <Section title="8. Third-Party Services">
  <ul style={styles.list} className="pp-list">
    <li>
      <strong>A. Google APIs & Firebase</strong>
      <ul style={styles.subList} className="pp-sublist">
        <li>
          Firebase Cloud Messaging (FCM): Sends order updates and notifications.
        </li>
        <li>
          Google Maps & Places APIs: Show nearby vendors and delivery addresses accurately.
        </li>
        <li>
          <strong>Privacy References:</strong>
          <ul style={styles.subList}>
            <li>
              <a
                href="https://firebase.google.com/support/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Firebase Privacy Policy
              </a>
            </li>
            <li>
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google APIs Privacy Policy
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </li>

    <li>
      <strong>B. Payment Gateway – Razorpay</strong>
      <ul style={styles.subList} className="pp-sublist">
        <li>
          Payments are securely processed via Razorpay, which collects necessary
          billing, card, and transaction information to complete payments.
        </li>
        <li>
          We do not store sensitive payment data on our servers.
        </li>
        <li>
          <a
            href="https://razorpay.com/privacy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Razorpay Privacy Policy
          </a>
        </li>
      </ul>
    </li>
  </ul>
</Section>


        <Section title="9. Children’s Privacy">
          <ul style={styles.list} className="pp-list">
            <li>This app is not intended for individuals under 18 years of age.</li>
          </ul>
        </Section>

        <Section title="10. Changes to This Policy">
          <ul style={styles.list} className="pp-list">
            <li>We may update this Privacy Policy from time to time.</li>
            <li>Updates will be posted inside the app.</li>
          </ul>
        </Section>

        <Section title="11. Contact Us">
          <ul style={styles.list} className="pp-list">
            <li>Company: Envision Integrated Services Pvt Ltd</li>
            <li>Email: envisionis.it@gmail.com</li>
          </ul>
        </Section>

        {/* Permissions Table */}
        <h3 style={styles.title}>📱 Permissions & Justifications</h3>

<table style={styles.table}>
  <thead>
    <tr>
      <th style={styles.th}>Permission</th>
      <th style={styles.th}>Purpose / Justification</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td style={styles.td}>ACCESS_FINE_LOCATION / ACCESS_COARSE_LOCATION</td>
      <td style={styles.td}>
        Used to determine the delivery partner’s location for navigation, assigning nearby orders, and real-time delivery tracking.
      </td>
    </tr>
    <tr>
      <td style={styles.td}>INTERNET</td>
      <td style={styles.td}>
        Required to communicate with backend servers for order updates, authentication, and app functionality.
      </td>
    </tr>
    <tr>
      <td style={styles.td}>CALL_PHONE</td>
      <td style={styles.td}>
        Allows delivery partners to contact customers or support directly from the app when required.
      </td>
    </tr>
    <tr>
      <td style={styles.td}>POST_NOTIFICATIONS</td>
      <td style={styles.td}>
        Used to send important notifications such as new orders, delivery updates, and alerts.
      </td>
    </tr>
    <tr>
      <td style={styles.td}>FOREGROUND_SERVICE</td>
      <td style={styles.td}>
        Used to enable continuous location tracking during active deliveries, ensuring real-time updates and accurate order completion.
      </td>
    </tr>
    <tr>
      <td style={styles.td}>REQUEST_IGNORE_BATTERY_OPTIMIZATIONS</td>
      <td style={styles.td}>
        This permission is used only to ensure uninterrupted operation of delivery tracking during active orders.<br />
        It helps prevent the system from stopping essential background services required for real-time location updates.<br />
        This is strictly used during active deliveries and is necessary to maintain service reliability and order accuracy.<br />
        Users are informed and can control this setting from their device system settings.
      </td>
    </tr>
  </tbody>
</table>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div style={{ marginBottom: "18px" }}>
    <h3 style={{ fontSize: "20px", fontWeight: 600, color: "#333", marginBottom: 8 }}>
      {title}
    </h3>
    <div style={{ marginTop: 4, color: "#444" }}>{children}</div>
  </div>
);

const styles = {
  pageWrapper: { background: "#f7fafc", minHeight: "100vh", padding: 20,marginTop:"60px" },
  headerSection: { background: "#fff", padding: 18, borderRadius: 12, marginBottom: 20 },
  header: { display: "flex", justifyContent: "space-between", alignItems: "center" },
  heading: { fontSize: 26, fontWeight: 700, margin: 0 },
  card: { background: "#fff", padding: 24, borderRadius: 12, maxWidth: 1200, margin: "0 auto" },
  title: { fontSize: 20, fontWeight: 700, marginBottom: 10, color: "#0f62fe" },
  meta: { margin: "4px 0" },
  line: { margin: "18px 0", height: 1, background: "#e6e9ef", border: 0 },
  list: { paddingLeft: 20, listStyleType: "disc" },
  subList: { paddingLeft: 20, listStyleType: "circle" },
  table: { width: "100%", borderCollapse: "collapse", marginTop: 12 },
  th: { background: "#eef2ff", padding: 12, textAlign: "left" },
  td: { padding: 12, borderBottom: "1px solid #eee" },
};

export default PrivacyPolicy;

